import { problems } from '../../data/content';
import './Problems.css';

function Problems() {
  return (
    <section id="problemas" className="section problems">
      <div className="container">
        <div className="section-header">
          <h2>Sua empresa enfrenta algum destes desafios?</h2>
          <p>Se sim, há espaço real para automatizar e ganhar produtividade.</p>
        </div>

        <div className="problems-grid">
          {problems.map((item) => (
            <div key={item.title} className="problem-card">
              <span className="problem-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Problems;
